import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-totem-footer',
    templateUrl: './totem-footer.component.html',
    styleUrls: ['./totem-footer.component.scss'],
    standalone: false
})
export class TotemFooterComponent implements OnInit {

    constructor() { }

    @Input() configData:any;

    @Input() openSection:string;
    @Output() openSectionChange = new EventEmitter<string>();

    buttonList = [{
        id: 'home',
        icon: 'fa-home'
    }, {
        id: 'profile',
        icon: 'fa-user'
    }, {
        id: 'chat',
        icon: 'fa-message'
    }]

    ngOnInit(): void {
    }
}
